import Head from 'next/head';
import Script from 'next/script';

const Opta = (props) => {
    const { text } = props;
    const widgetsOpta = text?.match(/<opta-widget[\s\S]*?<\/opta-widget>/g);
    return widgetsOpta ? (
        <>
            <Head>
                <link href='https://statics.3cat.cat/esport3/css/core.opta-widgets.css' rel='stylesheet' type='text/css'></link>
                <link href='https://statics.3cat.cat/esport3/css/v3.all.opta-widgets.css' rel='stylesheet' type='text/css'></link>
            </Head>
            <Script src='https://statics.3cat.cat/esport3/js/opta-params-v3.min.js' />
            <Script src='https://secure.widget.cloud.opta.net/v3/v3.opta-widgets.js' />
            {widgetsOpta.map((widget, i) => (
                <div key={`widtget-opta-${i}`} dangerouslySetInnerHTML={{ __html: widget }} data-testid='opta' />
            ))}
        </>
    ) : (
        <></>
    );
};

export default Opta;
